import { memo, useEffect, useMemo, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzChip, BzHeading } from '../../../components';
import { handleModal } from "../../../redux/actions/modals";
import { useDispatch, useSelector } from 'react-redux';


const AddWatchlistModal = ({ arrWatchlists = [], arrOpenWatchlists = [], onAddWatchlist, onSelectFund, ...props }) => {
    const dispatch = useDispatch();
    const filteredWatchList = useMemo(() => arrWatchlists?.filter(elem => !arrOpenWatchlists.find(obj => { return elem.id === obj.id; })), [arrWatchlists, arrOpenWatchlists]);
    const [selectedFunds, setSelectedFunds] = useState([]);
    const modals = useSelector(state => state?.modals?.modals);


    useEffect(() => {
        if (filteredWatchList?.length) {
            setSelectedFunds(filteredWatchList);
        }
    }, [filteredWatchList]);

    const handleClose = () => {
        dispatch(handleModal([{ "ADD_WATCHLIST": false }]));
    };


    return (
        <BzModal size="lg" show={modals['ADD_WATCHLIST']} onHide={handleClose} centered className='p-3'>
            <BzModalHeader className='mt-4 px-5'>
                <Container fluid className='p-0 bdr-btm'>
                    <Row className='g-0 pb-2'>
                        <Col md={9} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size12 color-text'>Review &amp; Add this watchlist</div>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-self-center'>
                            <BzButton className='btn btn-md btn-outline btn-rounded' onClick={handleClose}>Go Back</BzButton>
                        </Col>
                    </Row>
                    <Row className='g-0 pb-3'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Trending Now - Invest in the latest funds</div>
                            <div className='font-regular font-size4 color-subtext ms-2'>(3 Funds)</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='mt-3 px-5 bdr-btm'>
                <Container fluid className='p-0'>
                    {arrWatchlists?.map((each, i) => (
                        <Row key={i} className='g-0 mb-3'>
                            <Col md={1} className='d-flex justify-content-start align-items-start'>
                                <input className='form-check-input' type="checkbox" value={i} onChange={(e) => onSelectFund(e.target.checked, each)} />
                            </Col>
                            <Col className='flex-column justify-content-start align-items-start'>
                                <Row className='g-0 mb-1'>
                                    <Col className='d-flex justify content-start'>
                                        <div className='font-medium font-size4 color-text'>{each?.fundName}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-1'>
                                    <Col className='d-flex justify content-start'>
                                        <div className='chips-wrap flex-wrap'>
                                            {each?.category?.map((categoryName, i) => <BzChip key={i} className='chips primary-chip text-uppercase me-2 mb-2'>{categoryName}</BzChip>)}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-1'>
                                    <Col className='d-flex justify content-start'>
                                        <div className='font-regular font-size2 color-text text-wrap'>{each?.Description}</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    ))}
                </Container>
            </BzModalBody>
            <BzModalFooter className='px-5'>
                <Container fluid className='p-0 mt-4'>
                    <Row className='g-0'>
                        <Col md={9} className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Add New Watchlist</div>
                            <BzHeading className='font-medium font-size3 color-text mx-1 text-truncate'>{'currentWatchListName'}</BzHeading>
                            <div className='notification-count font-regular float-start'>{arrOpenWatchlists.length}</div>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-primary text-uppercase' onClick={onAddWatchlist}>Done</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(AddWatchlistModal);